// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-biografija-js": () => import("./../../../src/pages/biografija.js" /* webpackChunkName: "component---src-pages-biografija-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-lista-js": () => import("./../../../src/pages/lista.js" /* webpackChunkName: "component---src-pages-lista-js" */),
  "component---src-pages-zamjenik-js": () => import("./../../../src/pages/zamjenik.js" /* webpackChunkName: "component---src-pages-zamjenik-js" */),
  "component---src-templates-blog-template-js": () => import("./../../../src/templates/blogTemplate.js" /* webpackChunkName: "component---src-templates-blog-template-js" */),
  "component---src-templates-page-template-js": () => import("./../../../src/templates/pageTemplate.js" /* webpackChunkName: "component---src-templates-page-template-js" */)
}

